import { keepNumbers } from "lib/helpers";

export function formatPhoneNumber(value: string): string {
  if (value.length === 0) {
    return "";
  }
  // Remove commas and dots
  value = keepNumbers(value);
  const length = value.length;
  switch (length) {
    case 0:
    case 1:
    case 2:
    case 3:
      break;
    case 4:
    case 5:
    case 6:
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
      break;
    default:
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      break;
  }
  return value;
}
